export const useSxStyles = () => {
  const panelWidth = 350;
  const topbarHeight = 50;
  const footerHeight = 50;

  return {
    root: {
      position: 'fixed',
      right: 0,
      top: topbarHeight,
      bottom: footerHeight,
      width: panelWidth,
      zIndex: 500,
      bgcolor: '#fafafa',
      border: '1px solid rgba(0,0,0,0.08)',
      borderRight: 'none',
      boxShadow: '-6px 0 16px rgba(0,0,0,0.10)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    container: {
      height: 44,
      px: 1.25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: '#fafafa',
      borderBottom: '1px solid rgba(0,0,0,0.06)',
    },
  };
};
